import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const usePageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: 'pageview',
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location]);
};
